import { Facebook, Instagram, Linkedin, PartyPopper } from "lucide-react";
import { Link } from "react-router-dom";
import GlobalFooter from "./GlobalFooter";
import { performances, categories } from "@/data/performances";

export const Footer = () => {
  const getCategoryPerformances = (categorySlug: string) =>
    performances.filter((p) => p.category === categorySlug);

  return (
    <footer className="bg-[hsl(220,20%,12%)] border-t border-[hsl(220,20%,20%)] py-16 text-[hsl(210,14%,83%)]">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 text-center md:text-left">
          <div>
            <div className="flex items-center gap-2 justify-center md:justify-start mb-4">
              <PartyPopper className="w-6 h-6 text-[hsl(217,91%,60%)]" />
              <h3 className="font-outfit font-bold text-xl text-white">WystepyFirmowe.pl</h3>
            </div>
            <p className="text-sm leading-relaxed opacity-70">
              Kompleksowa oprawa artystyczna eventów firmowych.<br />
              Ponad 80 atrakcji w całej Polsce.
            </p>
          </div>
          <div>
            <h4 className="font-outfit font-bold text-white mb-4">Kontakt</h4>
            <p className="text-sm opacity-70">
              Email: <a href="mailto:kontakt@wystepyfirmowe.pl" className="hover:text-[hsl(217,91%,60%)] transition-colors">kontakt@wystepyfirmowe.pl</a>
            </p>
            <p className="text-sm opacity-70">Tel: +48 533 333 993</p>
          </div>
          <div>
            <h4 className="font-outfit font-bold text-white mb-4">Social Media</h4>
            <div className="flex gap-3 justify-center md:justify-start">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center opacity-70 hover:opacity-100 hover:border-[hsl(217,91%,60%)]/30 transition-all">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* SEO Footer Links */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <h4 className="font-outfit font-bold text-white text-center mb-8">Katalog atrakcji</h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {categories.map((cat) => (
              <div key={cat.slug}>
                <h5 className="font-outfit font-semibold text-white/60 text-xs uppercase tracking-wider mb-3">
                  {cat.name}
                </h5>
                <ul className="space-y-1.5">
                  {getCategoryPerformances(cat.slug).map((perf) => (
                    <li key={perf.slug}>
                      <Link
                        to={`/atrakcje/${perf.slug}`}
                        className="text-white/40 text-xs hover:text-[hsl(217,91%,60%)] transition-colors leading-tight block"
                      >
                        {perf.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mt-8 text-xs opacity-50">
          <Link to="/rodo" className="hover:text-[hsl(217,91%,60%)] transition-colors">Obowiązek informacyjny RODO</Link>
          <span>|</span>
          <Link to="/polityka-prywatnosci" className="hover:text-[hsl(217,91%,60%)] transition-colors">Polityka prywatności</Link>
          <span>|</span>
          <Link to="/regulamin" className="hover:text-[hsl(217,91%,60%)] transition-colors">Regulamin serwisu</Link>
        </div>
        <GlobalFooter />
      </div>
    </footer>
  );
};
